export var SCHEMA_TYPES = {
    BLOG_POST_BLOG_POSTING: 'blog-post-blog-posting-preset',
    BLOG_POST_NEWS_ARTICLE: 'blog-post-news-article-preset',
    BLOG_POST_ARTICLE: 'blog-post-article-preset',
    BLOG_POST_FAQ: 'blog-post-faq-preset', // TODO: Create a 'Shared Schema Types' to share between adapters (for components sd) and import FAQ type
};
